module.exports = __webpack_public_path__ + "img/golf-club.14430381.png";